<template>
  <section
    id="createSketch"
    class="d-flex justify-center">
    <v-form
      ref="sketchForm"
      v-model="formValid"
      lazy-validation
    >
      <v-row no-gutters>
        <v-col
          ref="sketchTitle"
          cols="12"
          class="white my-4 pa-4 elevation-2 rounded">
          <h1 class="title">
            {{ pageTitle }}
          </h1>
        </v-col>
        <v-col
          cols="12"
          class="d-flex flex-wrap  white my-4 pa-4 elevation-2 rounded">
          <v-col cols="12">
            <h2>Sketch Information</h2>
          </v-col>
          <v-col
            cols="12"
            md="6">
            <v-text-field
              v-model="form.sketchId"
              :rules="isEdit ? textBoxRules : []"
              class="uppercase"
              outlined
              label="Sketch ID"
              hide-details />
          </v-col>
          <v-col
            cols="12"
            md="6">
            <tree-select
              v-model="form.category"
              :items="selectOptions.categories"
              label="Product Types *"
              item-text="name"
              item-value="id"
              sub-property="children"
              return-object
              hide-details
              :rules="textBoxRules" />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="3">
            <v-autocomplete
              v-model="form.collectionId"
              label="Collection *"
              color="secondary"
              :rules="textBoxRules"
              :items="selectOptions.collections"
              item-text="name"
              item-value="id"
              outlined
              hide-details
              return-object
              @change="onSelectCollection" />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="3">
            <v-select
              v-model="form.brand"
              :items="selectOptions.brands"
              :rules="textBoxRules"
              item-text="name"
              item-value="name"
              :menu-props="{ offsetY: true }"
              label="Brand *"
              outlined
              hide-details />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="3">
            <v-autocomplete
              v-model="form.designer"
              :items="designersWithHeader"
              :rules="textBoxRules"
              :menu-props="{ offsetY: true }"
              label="Designer *"
              item-text="name"
              item-value="id"
              return-object
              outlined
              hide-details />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="3">
            <v-autocomplete
              v-model="form.merchandiser"
              :items="merchandisersWithHeader"
              :rules="textBoxRules"
              :menu-props="{ offsetY: true }"
              label="Merchandiser *"
              item-text="name"
              item-value="id"
              return-object
              outlined
              hide-details />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="3">
            <v-autocomplete
              v-model="form.graphic"
              :items="graphicsWithHeader"
              :rules="textBoxRules"
              :menu-props="{ offsetY: true }"
              label="Graphic *"
              item-text="name"
              item-value="id"
              return-object
              outlined
              hide-details>
              <template v-slot:item="{item}">
                <template v-if="typeof item !== 'object'">
                  <v-list-item-content v-text="data.item"></v-list-item-content>
                </template>
                <template v-else>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item.name }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="3">
            <v-autocomplete
              v-model="form.stylist"
              :items="creativesWithHeader"
              :rules="textBoxRules"
              :menu-props="{ offsetY: true }"
              label="Creative / Stylist *"
              item-text="name"
              item-value="id"
              return-object
              outlined
              hide-details />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="3">
            <v-autocomplete
              v-model="form.visualMerchandiser"
              :items="visualMerchandiserWithHeader"
              :rules="textBoxRules"
              :menu-props="{ offsetY: true }"
              label="Visual Merchandiser *"
              item-text="name"
              item-value="id"
              return-object
              outlined
              hide-details />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="3">
            <v-autocomplete
              v-model="form.marketing"
              :items="marketingsWithHeader"
              :rules="textBoxRules"
              :menu-props="{ offsetY: true }"
              label="Marketing *"
              item-text="name"
              item-value="name"
              return-object
              outlined
              hide-details />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="3">
            <v-autocomplete
              v-model="form.producer"
              :items="producersWithHeader"
              :rules="textBoxRules"
              :menu-props="{ offsetY: true }"
              label="Producer *"
              item-text="name"
              item-value="id"
              return-object
              outlined
              hide-details />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="3">
            <v-autocomplete
              v-model="form.classification"
              label="Classification *"
              color="secondary"
              :rules="textBoxRules"
              :items="selectOptions.classifications"
              outlined
              hide-details />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="3">
            <v-autocomplete
              v-model="form.factory"
              :items="selectOptions.factories"
              :menu-props="{ offsetY: true }"
              label="Factory"
              item-text="name"
              return-object
              outlined
              hide-details />
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="form.note"
              label="Note"
              outlined />
          </v-col>
          <v-col cols="12">
            <v-checkbox
              v-model="form.requirePrintCareLabel"
              label="ต้องปรินท์ Care label"></v-checkbox>
            <v-checkbox
              v-model="form.requirePrintFabricLabel"
              label="ต้องปรินท์ Fabric label"></v-checkbox>
          </v-col>
        </v-col>
        <v-col
          cols="12"
          class=" white my-4 pa-8 elevation-2 rounded">
          <h2 class="mb-4">
            Sketch Picture
          </h2>
          <gw-drop-file
            v-model="form.images"
            :multiple="true"
            need-compress
            s3-path="/sketch-images"
            caption="คลิกเพื่อเพิ่มรูปภาพ" />
        </v-col>
        <v-col
          cols="12"
          class=" white my-4 pa-8 elevation-2 rounded">
          <h2>
            Fabrics
          </h2>
          <fabric-stage
            v-model="form.fabrics"
            :required-composition="form.requirePrintFabricLabel"
            :is-sketch="false"
            :form-validates="fabricFormValidates" />
        </v-col>
        <v-col
          cols="12"
          class=" white my-4 pa-8 elevation-2 rounded">
          <h2>
            Materials
          </h2>
          <material-stage
            v-model="form.materials"
            :is-sketch="false"
            :form-validates="materialFormValidates" />
        </v-col>
        <v-col
          cols="12"
          class=" white my-4 pa-8 elevation-2 rounded">
          <h2>Garment Type</h2>
          <v-select
            v-model="form.garmentType"
            class="mt-4"
            dense
            :items="selectOptions.garmentType"
            :menu-props="{ offsetY: true }"
            label="Garment Type"
            item-text="name"
            item-value="value"
            outlined
            hide-details
          />
        </v-col>
        <v-col
          cols="12"
          class=" white my-4 pa-8 elevation-2 rounded">
          <h2> Care Label </h2>
          <v-select
            v-model="form.careLabel"
            class="mt-4"
            dense
            :items="selectOptions.careLabels"
            :menu-props="{ offsetY: true }"
            label="Care Label"
            item-text="name"
            return-object
            outlined
            hide-details
            @change="(v) => getCareLabelProductExample(v.id)" />
          <div v-if="form.careLabel">
            <img
              class="mt-4"
              :src="$convertImgix(`${form.careLabel.imageUrl}?w=1024`)"
              width="300"
              alt="">
          </div>
          <div v-if="productExamples.length">
            <p class="text-bold mt-4">
              Latest items with this Care Label
            </p>
            <div
              class="d-flex flex-wrap my-4">
              <v-card
                v-for="(product, index) in productExamples"
                :key="`example-${index}`"
                elevation="2"
                max-width="120"
                class="mx-2"
              >
                <v-img
                  :src="$convertImgix(`${product.photoUrl}?w=1024`)"
                  :alt="`example-${index}`"
                  height="80%"
                />

                <v-card-text
                  class="py-2 text-truncate text-center"
                  style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                >
                  {{ product.name }}
                </v-card-text>
              </v-card>
            </div>
          </div>
          <div v-if="loadingExample">
            <p class="text-bold mt-4">
              Latest items with this Care Label
            </p>
            <v-icon
              large
              class="mdi-spin"
              color="primary">
              mdi-loading
            </v-icon>
          </div>
        </v-col>
        <v-col
          cols="12"
          class="d-flex flex-wrap  white my-4 pa-4 elevation-2 rounded">
          <v-col cols="12">
            <h2>Sizing</h2>
          </v-col>
          <v-col cols="12">
            <v-combobox
              v-model="sizeDetail"
              :items="sizes"
              label="Size"
              multiple
              outlined
              deletable-chips
              :return-object="false"
              small-chips
              dense
              color="secondary" />
          </v-col>
          <v-col cols="12">
            <sizing-detail
              v-model="form.sizeDetail"
              :size-unit.sync="form.sizeUnit" />
          </v-col>
          <v-btn
            color="success"
            class="mt-8"
            large
            style="width: 100%;"
            :disabled="!formValid"
            @click="tryToCreateSketch()">
            {{ submitText }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import GetImageOrGradientCss from '@/assets/js/GetImageOrGradientCss'
import SketchProvider from '@/resources/SketchProvider'
import FactoryProvider from '@/resources/FactoryProvider'
import PrototypeCategoryProvider from '@/resources/PrototypeCategoryProvider'
import ProductAttributeProvider from '@/resources/ProductAttributeProvider'
import MaterialStage from '../components/MaterialStage.vue'
import SizingDetail from '../components/SizingDetail.vue'
import TreeSelect from '../components/TreeSelect.vue'
import FabricStage from '../components/FabricStage.vue'
import PrototypeOrderProvider from '@/resources/PrototypeOrderProvider'
import CareLabelProvider from '@/resources/CareLabelProvider'
import FabricsProvider from '@/resources/FabricsProvider'
import PrototypeAttributeProvider from '@/resources/PrototypeAttributeProvider'

const SketchService = new SketchProvider()
const FactoryService = new FactoryProvider()
const PrototypeAttributeService = new PrototypeAttributeProvider()
const PrototypeCategoryService = new PrototypeCategoryProvider()
const ProductAttributeService = new ProductAttributeProvider()
const CareLabelService = new CareLabelProvider()
const PrototypeOrderService = new PrototypeOrderProvider()

export default {
  components: {
    MaterialStage,
    SizingDetail,
    TreeSelect,
    FabricStage
  },
  data () {
    return {
      fabricService: new FabricsProvider(),
      form: {
        sketchNo: 0,
        images: [],
        materials: [
          {
            id: '',
            sketchId: '',
            materialId: '',
            imageUrls: [],
            name: '',
            factory: '',
            color: '',
            size: '',
            material: '',
            unitPrice: 0,
            amount: 0,
            currency: 'thb',
            collectionName: '',
            patterns: [
              {
                note: '',
                imageUrls: []
              }
            ],
            note: ''
          }
        ],
        fabrics: [
          {
            sketchId: '',
            hangId: '',
            fabricNo: '',
            imageUrls: [],
            factory: '',
            size: '',
            color: '',
            amount: 0,
            unitPrice: 0,
            currency: 'thb',
            collectionName: '',
            patterns: [
              {
                note: '',
                imageUrls: []
              }
            ],
            note: '',
            garmentPart: null
          }
        ],
        sketchId: '',
        designer: {
          id: '',
          name: ''
        },
        factory: {
          id: '',
          name: ''
        },
        category: {
          id: null,
          name: '',
          parentId: null
        },
        merchandiser: {
          id: '',
          name: ''
        },
        graphic: {
          id: '',
          name: ''
        },
        stylist: {
          id: '',
          name: ''
        },
        visualMerchandiser: {
          id: '',
          name: ''
        },
        collectionId: null,
        collectionName: null,
        classification: '',
        note: '',
        sizeDetail: [],
        sizeUnit: '',
        model: '',
        brand: '',
        careLabel: null,
        requirePrintCareLabel: true,
        requirePrintFabricLabel: true
      },
      selectOptions: {
        designers: [],
        factories: [],
        merchandisers: [],
        graphics: [],
        stylists: [],
        marketings: [],
        visualMerchandisers: [],
        producers: [],
        categories: [],
        colors: [],
        size: [],
        brands: [],
        collections: [],
        classifications: ['Core', 'Directional', 'Essential'],
        careLabels: [],
        garmentType: [
          {
            name: 'Knit',
            value: 'knit'
          },
          {
            name: 'Woven',
            value: 'woven'
          },
          {
            name: 'No Garment',
            value: 'no garment'
          }
        ]
      },
      rawCategories: [],
      oldValue: null,
      textBoxRules: [
        (v) => {
          if (v === null || v === undefined) return 'This field is required'
          if (typeof v === 'string') return v.trim() !== '' || 'This field is required'
          if (typeof v === 'object') return !!v.id || 'This field is required'
          return true
        }
      ],
      formValid: false,
      isEdit: false,
      materialFormValidates: [],
      fabricFormValidates: [],
      productExamples: [],
      loadingExample: false,
      currentSquad: null
    }
  },
  computed: {
    ...mapGetters({
      recentlyRoute: 'Route/recentlyRoute'
    }),
    isRemakeSketch () {
      return !!this.$route?.params?.remake
    },
    hasParamId () {
      return !!this.$route?.params?.id
    },
    pageTitle () {
      return this.hasParamId ? 'Edit Sketch' : 'Create Sketch'
    },
    submitText () {
      return this.hasParamId ? 'SAVE' : 'CREATE'
    },
    sizes () {
      return this.selectOptions.size.map((s) => s.name)
    },
    sizeDetail: {
      get () {
        return this.form.sizeDetail.map((item) => item.size.trim())
      },
      set (newVal) {
        const newArr = [...new Set(newVal)].filter((s) => this.sizes.includes(s))
        this.setSizeDetail(newArr)
      }
    },
    designersWithHeader () {
      const designers = this.selectOptions.designers || []

      return this.filterSquadMember(designers)
    },
    creativesWithHeader () {
      const creative = this.selectOptions.stylists || []

      return this.filterSquadMember(creative)
    },
    merchandisersWithHeader () {
      const merchandisers = this.selectOptions.merchandisers || []

      return this.filterSquadMember(merchandisers)
    },
    graphicsWithHeader () {
      const graphics = this.selectOptions.graphics || []

      return this.filterSquadMember(graphics)
    },
    marketingsWithHeader () {
      const marketings = this.selectOptions.marketings || []

      return this.filterSquadMember(marketings)
    },
    visualMerchandiserWithHeader () {
      const visualMerchandiser = this.selectOptions.visualMerchandisers || []

      return this.filterSquadMember(visualMerchandiser)
    },
    producersWithHeader () {
      const producers = this.selectOptions.producers || []

      return this.filterSquadMember(producers)
    }
  },
  watch: {
    'form.materials': {
      handler (newData) {
        this.materialFormValidates = newData.map((mat) => this.cleanMaterials([mat], false))
      },
      deep: true
    },
    'form.fabrics': {
      handler (newData) {
        this.fabricFormValidates = newData.map((fab) => this.cleanFabrics([fab], false))
        if (this.fabricFormValidates.length && this.fabricFormValidates.includes(false)) {
          this.$refs.sketchForm.validate()
        }
      },
      deep: true
    }
  },
  async mounted () {
    await this.initSelectOptions()

    if (this.$route?.params?.id) {
      this.isEdit = true
      this.getSketch(this.$route.params.id)
    }
    this.oldValue = JSON.parse(JSON.stringify(this.form))
  },
  methods: {
    ...mapActions({
      setSnackbar: 'Components/setSnackbar',
      setModal: 'Components/setModal',
      setLoading: 'Components/setLoading',
      setDarkMode: 'Style/setDarkMode',
      setIsWebpSupported: 'Style/setIsWebpSupported',
      initStore: 'Store/initStore'
    }),
    filterSquadMember (job) {
      if (!Array.isArray(job) || job.length === 0) return []

      const currentSquad = this.currentSquad?.name || null

      return job
        .slice()
        .sort((a, b) => {
          const squadA = a.squad?.name || null
          const squadB = b.squad?.name || null

          if (currentSquad) {
            if (squadA === currentSquad && squadB !== currentSquad) return -1
            if (squadA !== currentSquad && squadB === currentSquad) return 1
          }

          if (!squadA && squadB) return 1
          if (squadA && !squadB) return -1

          return (squadA || '').localeCompare(squadB || '')
        })
        .reduce((acc, item) => {
          const squadName = item.squad?.name || 'No Squad'

          if (!acc.some((e) => e.header === squadName)) {
            acc.push({ header: squadName })
          }

          acc.push(item)
          return acc
        }, [])
    },
    setSizeDetail (newArr) {
      if (newArr.length >= this.form.sizeDetail.length) {
        newArr.forEach((size) => {
          const findIndex = this.form.sizeDetail.findIndex((item) => item.size === size)
          if (this.form.sizeDetail.length > 0 && findIndex !== -1) {
            this.form.sizeDetail.splice(findIndex, 1, {
              ...this.form.sizeDetail[findIndex]
            })
          } else if (this.form.sizeDetail.length > 0) {
            this.form.sizeDetail.push({
              options: this.form.sizeDetail[0].options.map((option) => ({
                key: option?.key || '',
                value: ''
              })),
              size
            })
          } else {
            this.form.sizeDetail.push({
              options: [{
                key: '',
                value: ''
              }],
              size
            })
          }
        })
      } else {
        this.form.sizeDetail.forEach((item, index) => {
          const findIndex = newArr.findIndex((size) => item.size === size)
          if (findIndex === -1) {
            this.form.sizeDetail.splice(index, 1)
          }
        })
      }
    },
    sizeDetailUpperCaseRules (value) {
      let data = true
      for (let i = 0; i < value.length; i++) {
        if (value[i] !== value[i].toLowerCase() || value[i].trim() === '' || value[i] !== value[i].trim()) {
          data = false
          break
        }
      }
      return data || 'Require to uppercase letter and no space.'
    },
    pushSquadMemberDel (job, field, data) {
      if (data.sketch[job]?.id && !this.selectOptions[field].some((item) => item.id === data.sketch[job].id)) {
        this.selectOptions[field].push({
          id: data.sketch[job]?.id,
          name: data.sketch[job]?.name,
          squad: { name: 'Deleted', id: 'deleted', status: 'deleted' },
          status: 'deleted'
        })
      }
    },
    async getSketch (id) {
      try {
        this.setLoading({
          active: true,
          clickAble: false,
          message: 'GETTING SKETCHES...'
        })

        const { data } = await SketchService.getOneSketchById(id)
        this.form = {
          ...this.form,
          ...data.sketch,
          sketchId: data.sketch?.sketchId?.toUpperCase() || '',
          collectionId: data.sketch?.collectionId || null,
          collectionName: data.sketch?.collectionName || null,
          classification: data.sketch?.classification || '',
          requirePrintCareLabel: data.requirePrintCareLabel ?? true,
          requirePrintFabricLabel: data.requirePrintFabricLabel ?? true
        }
        this.pushSquadMemberDel('designer', 'designers', data)
        this.pushSquadMemberDel('stylist', 'stylists', data)
        this.pushSquadMemberDel('merchandiser', 'merchandisers', data)
        this.pushSquadMemberDel('graphic', 'graphics', data)
        this.pushSquadMemberDel('marketing', 'marketings', data)
        this.pushSquadMemberDel('visualMerchandiser', 'visualMerchandisers', data)
        this.pushSquadMemberDel('producer', 'producers', data)

        this.currentSquad = this.selectOptions.collections
          .find((collection) => collection.name.toUpperCase() === data.sketch?.collectionName?.toUpperCase())
        this.form.materials = this.form.materials.length
          ? this.form.materials
          : [
            {
              id: '',
              sketchId: '',
              materialId: '',
              imageUrls: [],
              name: '',
              factory: '',
              color: '',
              size: '',
              material: '',
              unitPrice: 0,
              amount: 0,
              currency: 'thb',
              collectionName: '',
              patterns: [
                {
                  note: '',
                  imageUrls: []
                }
              ],
              note: ''
            }
          ]

        this.form.fabrics = this.form.fabrics.length
          ? this.form.fabrics
          : [
            {
              sketchId: '',
              hangId: '',
              fabricNo: '',
              imageUrls: [],
              factory: '',
              size: '',
              color: '',
              amount: 0,
              unitPrice: 0,
              currency: 'thb',
              collectionName: '',
              patterns: [
                {
                  note: '',
                  imageUrls: []
                }
              ],
              note: '',
              garmentPart: null
            }
          ]
      } catch (error) {
        console.error('getSketch', error)
        this.setSnackbar({
          value: true,
          message: `${error.code}: ${error.message}`,
          type: 'error'
        })
      } finally {
        this.setLoading({ active: false })
      }
    },
    async initSelectOptions () {
      try {
        this.setLoading({
          active: true,
          clickAble: false
        })

        const promised = await Promise.all([
          PrototypeAttributeService.getSquadMember({
            page: 1,
            itemsPerPage: 99999,
            sortBy: ['id'],
            sortDesc: [true]
          }),
          FactoryService.getAll(),
          PrototypeCategoryService.getAllMapped(),
          ProductAttributeService.getAllProductAttribute(),
          CareLabelService.getAll()
        ])

        this.selectOptions.designers = promised[0].data.results
          .filter((item) => item.job === 'designer')
          .map((item) => ({ id: item.id, status: item.status, name: item.name, squad: item.squad }))
        this.selectOptions.stylists = promised[0].data.results
          .filter((item) => item.job === 'creative')
          .map((item) => ({ id: item.id, status: item.status, name: item.name, squad: item.squad }))
        this.selectOptions.merchandisers = promised[0].data.results
          .filter((item) => item.job === 'merchandiser')
          .map((item) => ({ id: item.id, status: item.status, name: item.name, squad: item.squad }))
        this.selectOptions.graphics = promised[0].data.results
          .filter((item) => item.job === 'graphic')
          .map((item) => ({ id: item.id, status: item.status, name: item.name, squad: item.squad }))
        this.selectOptions.marketings = promised[0].data.results
          .filter((item) => item.job === 'marketing')
          .map((item) => ({ id: item.id, status: item.status, name: item.name, squad: item.squad }))
        this.selectOptions.visualMerchandisers = promised[0].data.results
          .filter((item) => item.job === 'visual_merchandiser')
          .map((item) => ({ id: item.id, status: item.status, name: item.name, squad: item.squad }))
        this.selectOptions.producers = promised[0].data.results
          .filter((item) => item.job === 'producer')
          .map((item) => ({ id: item.id, status: item.status, name: item.name, squad: item.squad }))
        this.selectOptions.factories = promised[1].data.results
          .map((item) => ({ id: item.id, status: item.status, name: item.name, squad: item.squad }))
          .sort((a, b) => a.id - b.id)
        this.selectOptions.categories = promised[2].data.map((d) => ({
          ...d,
          disabled: d.name === 'UNKNOWN'
        }))
        this.selectOptions.colors = promised[3].data.colors ? this.getColor(promised[3].data.colors) : []
        this.selectOptions.brands = promised[3].data.brands ? promised[3].data.brands : []
        this.selectOptions.size = promised[3].data.size ? promised[3].data.size.sort((a, b) => a.id - b.id) : []
        this.selectOptions.collections = promised[3].data.collections ? promised[3].data.collections.map((c) => ({
          id: c.id,
          name: c.name.toUpperCase(),
          designer: c.designer,
          merchandiser: c.merchandiser,
          graphic: c.graphic,
          stylist: c.stylist,
          brand: c.brand,
          squad: c.squad
        })) : []
        this.selectOptions.careLabels = promised[4]?.data ? promised[4]?.data : []
      } catch (error) {
        console.error('initSelectOptions', error)
        this.setSnackbar({
          value: true,
          message: `ERROR WHILE INIT OPTIONS: ${error.message}`,
          type: 'error'
        })
      } finally {
        this.setLoading({ active: false })
      }
    },
    getColor (arr, itemsDisabled) {
      return arr.map((color) => ({
        ...color,
        label: color.name,
        children: color.childs && color.childs.length > 0 ? this.getColor(color.childs, itemsDisabled) : undefined,
        gradientCss: GetImageOrGradientCss(color)
      }))
    },
    async updateSketch () {
      try {
        this.setLoading({
          active: true,
          clickAble: false,
          message: 'UPDATING SKETCHES...'
        })
        const payload = this.removeUnuseData(this.form)

        await SketchService.updateSketch(this.$route?.params?.id, this.setFormatSketch(payload))

        this.setSnackbar({
          value: true,
          message: 'Prototype has been updated',
          type: 'success'
        })

        this.redirectRoute('update')
      } catch (error) {
        console.error('updateSketch', error)
        this.setSnackbar({
          value: true,
          message: `${error.code}: ${error.message}`,
          type: 'error'
        })
      } finally {
        this.setLoading({ active: false })
      }
    },
    async tryToCreateSketch () {
      const valid = await this.$refs.sketchForm.validate()
      if (!valid) {
        const el = this.$refs.sketchTitle
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' })
        }

        return
      }
      if ((JSON.stringify(this.form) !== JSON.stringify(this.oldValue)) && (!this.hasParamId || this.isRemakeSketch)) {
        this.createSketch()
      } else if ((JSON.stringify(this.form) !== JSON.stringify(this.oldValue)) && this.hasParamId && !this.isRemakeSketch) {
        this.updateSketch()
      } else {
        this.setSnackbar({
          value: true,
          message: 'กรุณากรอกข้อมูล',
          type: 'error'
        })
      }
    },
    async createSketch () {
      try {
        this.setLoading({
          active: true,
          clickAble: false,
          message: 'GETTING SKETCHES...'
        })

        const payload = this.removeUnuseData(this.form)

        await SketchService.createSketch(this.setFormatSketch(payload))
        this.redirectRoute('create')
      } catch (error) {
        console.error('createSketch', error)
        this.setSnackbar({
          value: true,
          message: `${error.code}: ${error.message}`,
          type: 'error'
        })
      } finally {
        this.setLoading({ active: false })
      }
    },
    redirectRoute (status) {
      if (status === 'update' && this.recentlyRoute?.name === 'SketchList') {
        this.$router.push(this.recentlyRoute)
      } else {
        this.$router.push({ name: 'SketchList' })
      }
    },
    objectEqual (object1, object2) {
      const keys1 = Object.keys(object1)
      const keys2 = Object.keys(object2)

      if (keys1.length !== keys2.length) {
        return false
      }

      for (const key of keys1) {
        const val1 = object1[key]
        const val2 = object2[key]
        const areObjects = this.isObject(val1) && this.isObject(val2)
        if ((areObjects && !this.objectEqual(val1, val2)) || (!areObjects && val1 !== val2)) {
          return false
        }
      }

      return true
    },
    isObject (object) {
      return object != null && typeof object === 'object'
    },
    removeUnuseData (_obj) {
      const obj = _obj

      if ('materials' in obj) {
        obj.materials = this.cleanMaterials(obj.materials)
      }

      if ('fabrics' in obj) {
        obj.fabrics = this.cleanFabrics(obj.fabrics)
      }

      const keys = Object.keys(obj)

      keys.forEach((key) => {
        if (key !== 'options') {
          if (obj[key] && (this.isObject(obj[key]) && JSON.stringify(obj[key]) !== '{}')) {
            obj[key] = this.removeUnuseData(obj[key])
          } else if (
            obj[key] === undefined
            || obj[key] === null
            || (typeof obj[key] === 'string' && obj[key] === '')
            || (typeof obj[key] === 'object' && JSON.stringify(obj[key]) === '{}')
          ) {
            delete obj[key]
          }
        }
      })

      return JSON.stringify(obj) !== '{}' ? obj : null
    },
    toUpperCase (val, key) {
      this.form[key] = val?.toUpperCase() || ''
    },
    cleanMaterials (materials, isClean = true) {
      const checkKeys = [
        {
          key: 'sketchId',
          type: 'string'
        },
        {
          key: 'materialId',
          type: 'string'
        },
        {
          key: 'imageUrls',
          type: 'array'
        },
        {
          key: 'name',
          type: 'string'
        },
        // {
        //   key: 'factory',
        //   type: 'string'
        // },
        {
          key: 'color',
          type: 'string'
        },
        {
          key: 'size',
          type: 'string'
        },
        {
          key: 'material',
          type: 'string'
        },
        {
          key: 'unitPrice',
          type: 'number'
        },
        {
          key: 'amount',
          type: 'number'
        },
        {
          key: 'currency',
          type: 'string',
          default: 'thb'
        },
        {
          key: 'collectionName',
          type: 'string'
        },
        // {
        //   key: 'patterns',
        //   type: 'array',
        //   default: [
        //     {
        //       note: '',
        //       imageUrls: []
        //     }
        //   ]
        // },
        {
          key: 'note',
          type: 'string'
        }
      ]

      if (isClean) {
        return materials
          .filter((mat) => !checkKeys.every((ck) => {
            switch (ck.type) {
              case 'string': return mat[ck.key] === '' || mat[ck.key] === ck?.default
              case 'number': return mat[ck.key] === 0 || mat[ck.key] === ck?.default
              case 'array': return mat[ck.key]?.length === 0 || JSON.stringify(mat[ck.key]) === JSON.stringify(ck?.default)
              default: return false
            }
          }))
          .map((mat) => ({
            ...mat,
            sketchId: mat?.sketchId?.toUpperCase() || '',
            name: mat?.name?.toUpperCase() || '',
            factory: mat?.factory?.toUpperCase() || '',
            color: mat?.color?.toUpperCase() || '',
            size: mat?.size?.toUpperCase() || '',
            material: mat?.material?.toUpperCase() || '',
            collectionName: mat?.collectionName?.toUpperCase() || ''
          }))
      }

      return materials.every((mat) => checkKeys.every((ck) => {
          switch (ck.type) {
            case 'string': return mat[ck.key] === '' || mat[ck.key] === ck?.default
            case 'number': return mat[ck.key] === 0 || mat[ck.key] === ck?.default
            case 'array': return mat[ck.key]?.length === 0 || JSON.stringify(mat[ck.key]) === JSON.stringify(ck?.default)
            default: return false
          }
        }))
    },
    cleanFabrics (fabrics, isClean = true) {
      const checkKeys = [
        {
          key: 'sketchId',
          type: 'string'
        },
        {
          key: 'hangId',
          type: 'string'
        },
        {
          key: 'fabricNo',
          type: 'string'
        },
        {
          key: 'imageUrls',
          type: 'array'
        },
        // {
        //   key: 'factory',
        //   type: 'string'
        // },
        {
          key: 'size',
          type: 'string'
        },
        {
          key: 'color',
          type: 'string'
        },
        {
          key: 'unitPrice',
          type: 'number'
        },
        {
          key: 'amount',
          type: 'number'
        },
        {
          key: 'currency',
          type: 'string',
          default: 'thb'
        },
        {
          key: 'collectionName',
          type: 'string'
        },
        // {
        //   key: 'patterns',
        //   type: 'array',
        //   default: [
        //     {
        //       note: '',
        //       imageUrls: []
        //     }
        //   ]
        // },
        {
          key: 'note',
          type: 'string'
        },
        {
          key: 'garmentPart',
          type: 'object',
          default: null
        }
      ]

      if (isClean) {
        return fabrics
          .filter((fab) => !checkKeys.every((ck) => {
            switch (ck.type) {
              case 'string': return fab[ck.key] === '' || fab[ck.key] === ck?.default
              case 'number': return fab[ck.key] === 0 || fab[ck.key] === ck?.default
              case 'array': return fab[ck.key].length === 0 || JSON.stringify(fab[ck.key]) === JSON.stringify(ck?.default)
              case 'object': return fab[ck.key] === ck?.default
              default: return false
            }
          }))
          .map((fab) => ({
            ...fab,
            sketchId: fab?.sketchId?.toUpperCase() || '',
            hangId: fab?.hangId?.toUpperCase() || '',
            fabricNo: fab?.fabricNo?.toUpperCase() || '',
            factory: fab?.factory?.toUpperCase() || '',
            size: fab?.size?.toUpperCase() || '',
            color: fab?.color?.toUpperCase() || '',
            collectionName: fab?.collectionName?.toUpperCase() || ''
          }))
      }

      return fabrics.every((fab) => checkKeys.every((ck) => {
          switch (ck.type) {
            case 'string': return fab[ck.key] === '' || fab[ck.key] === ck?.default
            case 'number': return fab[ck.key] === 0 || fab[ck.key] === ck?.default
            case 'array': return fab[ck.key].length === 0 || JSON.stringify(fab[ck.key]) === JSON.stringify(ck?.default)
            case 'object': return fab[ck.key] === ck?.default
            default: return false
          }
        }))
    },
    setFormatSketch (sketch) {
      const materials = sketch.materials
        .filter((mat) => ((mat.id && mat.name) || (!mat.id && mat.name)))
        .map(({ collectionName, ...v }) => ({
          ...v,
          sketchId: this.form.sketchId || ''
        }))
      const fabrics = sketch.fabrics
        .filter((fab) => ((fab.id && fab.hangId && fab.fabricNo) || (!fab.id && fab.hangId && fab.fabricNo)))
        .map(({ collectionName, ...v }) => ({
          ...v,
          sketchId: this.form.sketchId || ''
        }))

      const { collectionName, ...restSketch } = sketch

      return {
        ...restSketch,
        careLabel: sketch?.careLabel?.id || null,
        sketchId: sketch?.sketchId?.toUpperCase() || '',
        collectionId: sketch.collectionId || null,
        collectionName,
        materials,
        fabrics
      }
    },
    onSelectCollection (collection) {
      this.form.collectionId = collection.id
      this.form.collectionName = collection.name
      this.form.designer = collection?.designer || ''
      this.form.merchandiser = collection?.merchandiser || ''
      this.form.graphic = collection?.graphic || ''
      this.form.stylist = collection?.stylist || ''
      this.form.marketing = collection?.marketing || ''
      this.form.visualMerchandiser = collection?.visualMerchandiser || ''
      this.form.producer = collection?.producer || ''
      this.form.brand = collection?.brand || ''
      this.currentSquad = collection.squad
    },
    async getCareLabelProductExample (careLabelId) {
        this.productExamples = []
        this.loadingExample = true
        const { data } = await PrototypeOrderService.getCareLabelProductExample(careLabelId)
        this.productExamples = data
        this.loadingExample = false
    }
  }
}
</script>

<style scoped>

.field-label {
  font-weight: bold;
}
.uppercase input {
  text-transform: uppercase;
}
</style>
